// extracted by mini-css-extract-plugin
module.exports = {"item_breadcrumb":"styles_item_breadcrumb__eYGFd","last_breadcrumb":"styles_last_breadcrumb__c7IQm"};